export enum VideoUploadType {
  TemplateVideo = 'TemplateVideo',
  CreativeVideo = 'CreativeVideo',
  ProductFeedLibraryVideo = 'ProductFeedLibraryVideo',
  LocationFeedLibraryVideo = 'LocationFeedLibraryVideo',
  ClientLibraryVideo = 'ClientLibraryVideo',
  StaticVideo = 'StaticVideo',
}

export enum ImageUploadType {
  TemplateImage = 'TemplateImage',
  TemplateStaticImage = 'TemplateStaticImage',
  TemplatePoster = 'TemplatePoster',
  CreativeImage = 'CreativeImage',
  CreativePoster = 'CreativePoster',
  FeedDefaultImage = 'FeedDefaultImage',
  ProductFeedLibraryImage = 'ProductFeedLibraryImage',
  LocationFeedLibraryImage = 'LocationFeedLibraryImage',
  ClientLibraryImage = 'ClientLibraryImage',
}
